import React, { useEffect, useState } from "react";
import Header from "../../../layouts/Header";
import CaseReversalPanel from "./CaseReversalPanel";
import { ToastContainer } from "react-toastify";

const PaymentsAdminPanel = () => {
  const initialState = { showNavigationModal: false };

  const [paymentsAdminPanelState, setPaymentsAdminPanelState] =
    useState(initialState);

  return (
    <span>
      <Header
        isNavigationModal={paymentsAdminPanelState.showNavigationModal}
        closeNavigationModal={() =>
          setPaymentsAdminPanelState({
            ...paymentsAdminPanelState,
            showNavigationModal: false,
          })
        }
        openNavigationModal={() =>
          setPaymentsAdminPanelState({
            ...paymentsAdminPanelState,
            showNavigationModal: true,
          })
        }
      ></Header>
      <div className="container-fluid">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />
        <div className="row">
          <div className="main_wrapper">
            <div className="overlay" id="navigation-overly"></div>
            <section className="right_wrapper">
              <div className="panel-white">
                <div className="grayFiltr-bg brdr-FB clearfix">
                  <div className="col-md-12 ">
                    <h3 className="list_title clearfix">
                      Payments Admin Panel
                    </h3>
                  </div>
                </div>

                <div className="container-fluid">
                  <div className="main_wrapper">
                    <section className="right_wrapper">
                      <div className="panel-white">
                        <div className="filter_flyout">
                          <div className="filter_box filter-section-bx">
                            <div className="page-title">
                              <div className="title_left">
                                <div className="">
                                  <h3 id="filterDiv">{""}</h3>
                                </div>
                              </div>
                            </div>
                            <div className="clearfix" id="list_data">
                              <div className="list-box">
                                <ul
                                  className="nav nav-tabs bar_tabs"
                                  role="tablist"
                                >
                                  <li
                                    data-input="1"
                                    role="presentation"
                                    className="active"
                                  >
                                    <a
                                      href="/#"
                                      aria-controls="ops-cases"
                                      role="tab"
                                      data-toggle="tab"
                                      data-status="1"
                                    >
                                      Case Reversal
                                    </a>
                                  </li>
                                </ul>
                                <div className="tab-content clearfix">
                                  <CaseReversalPanel></CaseReversalPanel>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </span>
  );
};

export default PaymentsAdminPanel;
